import Popup from 'devextreme-react/popup';
import { useMemo, useState, type MouseEvent } from 'react';
import { publicDashboardTipAssetUrl } from './tipAssetMarkdown';
import { renderTipBodyHtml } from './tipBodyRender';

export interface TipBodyViewProps {
  markdown: string;
  assetUrl?: (id: string) => string;
  className?: string;
}

export function TipBodyView({
  markdown,
  assetUrl = publicDashboardTipAssetUrl,
  className
}: TipBodyViewProps) {
  const html = useMemo(() => renderTipBodyHtml(markdown, assetUrl), [assetUrl, markdown]);
  const [lightbox, setLightbox] = useState<{ src: string; alt: string } | null>(null);

  const onClick = (event: MouseEvent<HTMLDivElement>) => {
    const target = event.target;
    if (!(target instanceof HTMLImageElement) || !target.src) return;
    event.preventDefault();
    setLightbox({ src: target.currentSrc || target.src, alt: target.alt || 'Tip image' });
  };

  return (
    <>
      <div
        className={className}
        onClick={onClick}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <Popup
        visible={lightbox != null}
        onHiding={() => setLightbox(null)}
        showTitle
        title={lightbox?.alt ?? 'Image'}
        width="80vw"
        height="80vh"
        maxWidth="80vw"
        maxHeight="80vh"
        hideOnOutsideClick
        dragEnabled={false}
        wrapperAttr={{ class: 'dashboard-tips-lightbox-popup' }}
        contentRender={() =>
          lightbox ? (
            <div className="dashboard-tips-lightbox">
              <img className="dashboard-tips-lightbox__img" src={lightbox.src} alt={lightbox.alt} />
            </div>
          ) : null
        }
      />
    </>
  );
}
